import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import FileSaver from "file-saver";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienEditdialog from "./SuKienEditDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import Tooltip from "@material-ui/core/Tooltip";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import SuKienTimKiemControl from "./controls/SuKienTimKiemControl";
import ConfirmDialog from "./ConfirmDialog";
import AlertDialog from "./AlertDialog";
import "./sukien.css";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");

class SuKienPage extends React.Component {
  columns = [
    { field: "id", headerName: "STT", width: 40 },
    { field: "MaSK", headerName: "Mã số", width: 50 },
    { field: "TenNguonBao", headerName: "Nguồn báo", width: 230,
    renderCell: (params) => {
      console.log(params);
      return <div style={{color: params.row.Duyet ? 'black' : 'red'}} >{params.row.TenNguonBao}</div>
    }
   },
    {
      field: "TenSK",
      headerName: "Tên/Quốc tịch",
      width: 150,
      renderCell: (params) => {
        //console.log(params);
        return (
          <div style={{ lineHeight: "initial" }}>
            <a
              href="#"
              onClick={() => {
                this.setState({
                  Editting_MaSK: params.row.MaSK,
                  Editting_SuKien: params.data,
                  open_edit_sukien: true,
                  showConfirmXoa: false,
                });
              }}
            >
              <div>{params.row.TenSK} </div>
              <div>{params.row.TenQuocGia}</div>
            </a>
          </div>
        );
      },
    },
    {
      field: "ThoiGian",
      headerName: "Thời gian",
      width: 120,
      renderCell: (params) => (
        <div style={{ lineHeight: "initial" }}>
          <div>
            <Moment format="DD-MM-yyyy HH:mm">
              {params.row.ThoiGianBiNan}
            </Moment>
          </div>
          <div>
            <Moment format="DD-MM-yyyy HH:mm">
              {params.row.ThoiGianBaoNan}
            </Moment>
          </div>
          <div>
            <Moment format="DD-MM-yyyy HH:mm">
              {params.row.ThoiGian}
            </Moment>
          </div>
          <div>
            (
            {myLib.dateDiff(
              params.row.ThoiGianBaoNan,
              params.row.ThoiGianBiNan
            )}
            )
          </div>
        </div>
      ),
    },
    {
      field: "Lat",
      headerName: "Tọa độ",
      width: 85,
      renderCell: (params) => (
        <div style={{ lineHeight: "initial" }}>
          <div>
            {params.row.Lat !== null
              ? myLib.latToDMS(params.row.Lat)
              : ""}
          </div>
          <div>
            {params.row.Lon !== null
              ? myLib.lonToDMS(params.row.Lon)
              : ""}
          </div>
        </div>
      ),
    },
    {
      field: "ViTri",
      headerName: "Vị trí",
      width: 150,
      renderCell: (params) => (
        <Tooltip arrow title={<p>{params.row.ViTri}</p>}>
          <div style={{ overflow: "ellipsis" }}>{params.row.ViTri}</div>
        </Tooltip>
      ),
    },
    {
      field: "TinhTrang",
      headerName: "Tình trạng/Tóm tắt",
      width: 250,
      renderCell: (params) => (
        <div className="gridCell">
          <div className="cellTinhTrang">{params.row.TinhTrang}</div>
          <div>{params.row.TomTat}</div>
        </div>
      ),
    },
    { field: "TenTaiNan", headerName: "Tai nạn", width: 130 },
    {
      field: "TrangThai",
      headerName: "Trạng thái",
      width: 130,
      valueGetter: (params) =>
        params.row.TrangThai === 1 ? "Đang xử lý" : "Kết thúc",
    },
    { field: "TenVietTat", headerName: "Đơn vị", width: 200 },
  ];
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_them_sukien: false, //hien thi form nhap moi su kien
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_MaSK: undefined,
      showConfirmXoa: false,
      Editting_SuKien: undefined,
      showConfirmDuyet: false,
      errorLog: "",
    };
  }

  popupComp = undefined;

  componentDidMount() {}
  //call khi user thay doi trang
  handlePageChange = (params) => {
    if (this.callbackSearch) {
      this.callbackSearch(params.page);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Box display="flex">
          <SuKienTimKiemControl
            onSearched={(dieukien, data) => {
              var total = data.total;
              data.danhsach.map((item, index) => {
                item.id = index + 1 + (dieukien.Page - 1) * dieukien.PageSize;
              });
              var search = {};
              Object.assign(search, dieukien);
              this.setState({
                search: search,
                dataRows: data.danhsach,
                totalRows: data.total,
                search_result: data,
              });
            }}
            callback={(func) => (this.callbackSearch = func)}
          />
        </Box>

        <Box flexGrow={1}>
          <DataGrid
            rows={this.state.dataRows}
            columns={this.columns}
            id="MaSK"
            headerHeight={32}
            density="compact"
            rowHeight={100}
            className={classes.root}
            showCellRightBorder={true}
            showColumnRightBorder={true}
            pagination
            pageSize={this.state.search.PageSize}
            rowCount={this.state.totalRows}
            paginationMode="server"
            sortingMode="server"
            menuContainerStyle={{ zIndex: 999 }}
            onPageChange={this.handlePageChange}
            onCellClick={(params) => {
              //console.log(params);
              this.setState({
                Editting_MaSK: params.row.MaSK,
                Editting_SuKien: params.row,
              });
            }}
          />
        </Box>
        <Box alignSelf="flex-start" display="flex">
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={!global.User.Quyen.R221}
            icon={<AddCircleIcon />}
            text={"Thêm mới"}
            onClick={() => {
              //truy van tu server
              server
                .query("sukien/getdraft")
                .then((response) => {
                  if (response === null) {
                    this.setState({ open_them_sukien: true });
                  } else {
                    this.setState({
                      Editting_MaSK: response.MaSK,
                      open_edit_sukien: true,
                      showConfirmXoa: false,
                    });
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.setState({ open_them_sukien: true });
                });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<EditIcon />}
            text={"Sửa"}
            disabled={
              this.state.Editting_MaSK === undefined || (!global.User.Quyen.RX1 && (!global.User.Quyen.R221 || this.state.Editting_SuKien.MaCQ !== global.User.MaCQ))
            }
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: false,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<DeleteIcon />}
            text={"Xóa"}
            disabled={
              this.state.Editting_MaSK === undefined || (!global.User.Quyen.RX1 && (!global.User.Quyen.R221 || this.state.Editting_SuKien.MaCQ !== global.User.MaCQ))
            }
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: true,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<DeleteIcon />}
            text={"Duyệt"}
            disabled={
              this.state.Editting_MaSK === undefined || !global.User.Quyen.RX1 || (this.state.Editting_SuKien && this.state.Editting_SuKien.Duyet)
            }
            onClick={() => {
              console.log(this.state.Editting_SuKien);
              this.setState({
                showConfirmDuyet: true,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            icon={<ImportExportIcon />}
            text={"Xuất Excel"}
            onClick={() => {
              server
                .download("sukien/xuatexcel", this.state.search)
                .then((response) => {})
                .catch((error) => console.log(error));
            }}
          />
          {this.state.search_result !== undefined &&
          this.state.search_result.thongke !== undefined ? (
            <strong style={{ margin: 0 }}>
              [Tổng số sự vụ:{" "}
              {this.state.search_result.thongke.DangXL +
                this.state.search_result.thongke.KetThuc}]
               [ Chưa duyệt: {this.state.search_result.thongke.ChuaDuyet}]
               [Đang xử lý: {this.state.search_result.thongke.DangXL} ][Đã kết
              thúc: {this.state.search_result.thongke.KetThuc}]
            </strong>
          ) : null}
        </Box>
        {this.state.open_them_sukien ? (
          <SuKienEditdialog
            visible={this.state.open_them_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            onClose={() => this.setState({ open_them_sukien: false })}
          />
        ) : null}
        {this.state.open_edit_sukien ? (
          <SuKienEditdialog
            visible={this.state.open_edit_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            MaSK={this.state.Editting_MaSK}
            EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
            onClose={() =>
              this.setState({
                open_edit_sukien: false,
                Editting_MaSK: undefined,
              })
            }
          />
        ) : null}
        {this.state.open_chitiet_sukien ? (
          <SuKienChiTietDialog
            visible={this.state.open_chitiet_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            onClose={() => this.setState({ open_chitiet_sukien: false })}
          />
        ) : null}
        {this.state.showConfirmDuyet ? (
          <ConfirmDialog
            visible={this.state.showConfirmDuyet}
            maxWidth={"sm"}
            message={"Duyệt sự vụ: " + this.state.Editting_SuKien.TenSK}
            callback={(ok) => {
              //call server
              if (ok) {
                server
                  .post("sukien/duyet", { MaSK: this.state.Editting_MaSK })
                  .then((response) => {
                    //reload
                    this.state.Editting_SuKien.Duyet = true;
                    this.setState({ showConfirmDuyet: false, errorLog: "" });
                  })
                  .catch((error) => this.setState({ errorLog: error + "" }));
              }
              else
              {
                this.setState({ showConfirmDuyet: false });
              }
            }}
          />
        ) : null}
        {this.state.errorLog === "" ? null : (
          <AlertDialog
            visible={this.state.errorLog !== ""}
            message={this.state.errorLog}
            callback={() => this.setState({ errorLog: "" })}
          />
        )}
      </>
    );
  }
}
function customCheckbox(theme) {
  return {
    "& .MuiCheckbox-root svg": {
      width: 16,
      height: 16,
      backgroundColor: "transparent",
      border: `1px solid ${
        theme.palette.type === "light" ? "#494949" : "rgb(67, 67, 67)"
      }`,
      borderRadius: 2,
    },
    "& .MuiCheckbox-root svg path": {
      display: "none",
    },
    "& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg": {
      backgroundColor: "#1890ff",
      borderColor: "#1890ff",
    },
    "& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after": {
      position: "absolute",
      display: "table",
      border: "2px solid #fff",
      borderTop: 0,
      borderLeft: 0,
      transform: "rotate(45deg) translate(-50%,-50%)",
      opacity: 1,
      transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
      content: '""',
      top: "50%",
      left: "39%",
      width: 5.71428571,
      height: 9.14285714,
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after": {
      width: 8,
      height: 8,
      backgroundColor: "#1890ff",
      transform: "none",
      top: "39%",
      border: 0,
    },
  };
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  container1: {
    height: "100%",
    backgroundColor: "skyblue",
  },
  gridContainer: {
    height: "100vh",
  },
  root: {
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: theme.palette.type === "light" ? "#eaeaea" : "#1d1d1d",
    },
  },
  root1: {
    border: 0,
    color:
      theme.palette.type === "light"
        ? "rgba(0,0,0,.85)"
        : "rgba(255,255,255,0.85)",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    WebkitFontSmoothing: "auto",
    letterSpacing: "normal",
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: theme.palette.type === "light" ? "#5a5a5a" : "#1d1d1d",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-colCell, .MuiDataGrid-cell": {
      borderRight: `1px solid ${
        theme.palette.type === "light" ? "#505050" : "#303030"
      }`,
    },
    "& .MuiDataGrid-columnsContainer": {
      borderBottom: `1px solid ${
        theme.palette.type === "light" ? "#505050" : "#303030"
      }`,
      borderTop: `1px solid ${
        theme.palette.type === "light" ? "#505050" : "#303030"
      }`,
      overflow: "visible",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: `1px solid ${
        theme.palette.type === "light" ? "#505050" : "#303030"
      }`,
      color:
        theme.palette.type === "light"
          ? "rgba(0,0,0,.85)"
          : "rgba(255,255,255,0.65)",
    },
    "& .MuiPaginationItem-root": {
      borderRadius: 0,
    },
  },
});

export default withStyles(styles, { withTheme: true })(SuKienPage);
